import { render, staticRenderFns } from "./ClassicDimensionBoostRow.vue?vue&type=template&id=4808f9de&scoped=true"
import script from "./ClassicDimensionBoostRow.vue?vue&type=script&lang=js"
export * from "./ClassicDimensionBoostRow.vue?vue&type=script&lang=js"
import style0 from "./ClassicDimensionBoostRow.vue?vue&type=style&index=0&id=4808f9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4808f9de",
  null
  
)

export default component.exports